export type TransferredTicketKind = "waitlist_sold" | "user_transfer";

export const getTransferredTicketKind = (
  {
    purchased_by_id,
    current_owner,
  }: {
    purchased_by_id?: string;
    current_owner?: { id: string } | null;
  },
  attendeeId: string
): TransferredTicketKind => {
  // Historical records do not persist transfer source. This is the best
  // available signal, but a ticket returned to its purchaser is ambiguous.
  if (
    purchased_by_id &&
    purchased_by_id === current_owner?.id &&
    purchased_by_id !== attendeeId
  ) {
    return "waitlist_sold";
  }

  return "user_transfer";
};
